<template>
  <span>
    <span v-if="!edit_delete_mode">
      <b-button
        variant="light"
        :disabled="is_unlinked || !is_able_to_edit"
        class="py-1 px-2"
        v-b-tooltip.hover.bottom
        :title="is_able_to_edit ? '차트 사례 추가' : '결제가 필요합니다.'"
        @click.stop.prevent="addCharts"
      >
        <b-icon icon="bar-chart-line" />
      </b-button>
    </span>

    <span v-else>
      <b-button
        variant="light"
        class="py-1 px-2"
        v-b-tooltip.hover
        title="편집"
        @click.stop.prevent="addCharts"
      >
        <b-icon icon="vector-pen" />
      </b-button>
    </span>

    <b-modal
      v-model="show_modal"
      hide-footer
      :size="low_height ? 'sm' : 'xl'"
      :centered="!low_height"
      scrollable
      :modal-class="low_height ? 'minimized' : ''"
      :hide-backdrop="low_height"
      no-close-on-backdrop no-close-on-esc
    >
      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          차트 편집
          <div>
            <b-button variant="icon-light" @click="low_height = !low_height">
              <fa :icon="low_height ? 'expand' : 'compress'"></fa>
            </b-button>
            <b-button variant="icon-light" @click="closeModal">
              <fa icon="times"></fa>
            </b-button>
          </div>
        </div>
      </template>

      <div v-show="!low_height">
        <ChartCaseList
          v-if="modal_mode === 'chart_list'"
          :editing_mode="true"
          :dc_key_info="dc_key_info"
          :selected_chart_list="selected_chart_list"
          :selected_mng_chart_id="selected_mng_chart_id"
          @closeModal="closeModal"
          @flag_modal_mode="flag_modal_mode"
          :sb_disclosure_id="sb_disclosure_id"
        />

        <DefaultChart
          v-else-if="modal_mode === 'chart_edit'"
          :editing_mode="true"
          @flag_modal_mode="flag_modal_mode"
        />

        <ManageChart
          v-else-if="modal_mode === 'chart_manage'"
          :editing_mode="true"
          @flag_modal_mode="flag_modal_mode"
        />
      </div>
    </b-modal>
  </span>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import ChartCaseList from '@/components/writing_report/chart_subs/ChartCaseList.vue';
  import DefaultChart from '@/components/writing_report/chart_subs/DefaultChart';
  import ManageChart from '@/components/writing_report/chart_subs/ManageChart';

  export default {
    name: 'ChartBtn',
    computed: {
      ...mapState('report_list', ['report_code']),
    },
    props: {
      is_unlinked: { type: Boolean, default: () => false },
      is_able_to_edit: { type: Boolean, default: () => false },
      dc_key_info: { type: Array, default: () => [] },
      editing_gri_code: { type: String, default: () => '' },
      selected_chart_list: { type: Array, default: () => [] },
      edit_delete_mode: { type: Boolean, default: false },
      selected_mng_chart_id: { type: Number, default: null },
      sb_disclosure_id: { type: Number, default: () => null },
    },
    components: {
      ChartCaseList,
      DefaultChart,
      ManageChart,
    },
    data() {
      return {
        show_modal: false,
        low_height: false,
        modal_mode: 'chart_list', // "chart_list", "chart_edit", "chart_manage"
      };
    },
    beforeDestroy() {
      this.update_editing_gri_code('');
    },
    methods: {
      ...mapMutations('charts', ['update_selected_chart_id']),
      ...mapMutations('cursor', ['update_editing_gri_code']),
      ...mapActions('charts', ['getChartList']),
      addCharts() {
        if (this.editing_gri_code !== '') {
          this.update_editing_gri_code(this.editing_gri_code);
        }

        this.show_modal = true;

        if (this.edit_delete_mode) {
          this.modal_mode = 'chart_edit';
          this.update_selected_chart_id(this.selected_mng_chart_id);
        }

        this.getChartList({
          report_code: this.report_code,
          is_editing: true,
        });
        this.$emit('add-dc-tables', null);
      },
      closeModal() {
        this.show_modal = false;
      },
      flag_modal_mode(flag) {
        this.modal_mode = flag;
      },
    },
  };
</script>

<style></style>
